"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = settle;
exports.fetchAdapter = void 0;
var _axios = _interopRequireWildcard(require("axios"));
var _internals = require("../internals");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != (typeof e === "undefined" ? "undefined" : _type_of(e)) && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
    } else {
        reject(new _axios.AxiosError("Request failed with status code ".concat(response.status), [
            _axios.AxiosError.ERR_BAD_REQUEST,
            _axios.AxiosError.ERR_BAD_RESPONSE
        ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
    }
}
/**
 * Normalizes the given value to a string or an array of strings.
 * This function is stolen from axios and we hope it will work for us too. - https://github.com/axios/axios/blob/v1.x/lib/core/AxiosHeaders.js#L12
 * If the value is false or null, it is returned as is.
 * If the value is an array, each element is recursively normalized.
 * @param value The value to normalize.
 * @returns The normalized value.
 */ // @ts-expect-error -- TS does not like the recursive type
function normalizeValue(value) {
    if (value === false || value == null) {
        return value;
    }
    return Array.isArray(value) ? value.map(normalizeValue) : String(value);
}
/**
 * Converts axios headers to native headers
 */ var constructHeaders = function(headers) {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-return -- We are sure that the headers are of type Headers
    new Headers(Object.entries(headers.toJSON()).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return [
            key,
            normalizeValue(value)
        ];
    })));
};
function getRequest(config) {
    return _getRequest.apply(this, arguments);
}
function _getRequest() {
    _getRequest = _async_to_generator(function(config) {
        var response, rawHeaders, request, error, axiosResponse, _config_responseType, _;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    rawHeaders = constructHeaders(config.headers);
                    request = new Request((0, _internals.getUrl)(config), {
                        headers: rawHeaders,
                        keepalive: true
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch(request)
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        new _axios.AxiosError('Network Error', _axios.AxiosError.ERR_NETWORK, config, request)
                    ];
                case 4:
                    axiosResponse = {
                        status: response.status,
                        statusText: response.statusText,
                        config: config,
                        request: request,
                        headers: Object.fromEntries(Object.entries(new Headers(response.headers))),
                        // Make a copy of headers
                        // We will set data after
                        data: undefined
                    };
                    if (!(response.status >= 200 && response.status !== 204)) return [
                        3,
                        13
                    ];
                    _ = (_config_responseType = config.responseType) !== null && _config_responseType !== void 0 ? _config_responseType : response.headers.get('content-type');
                    switch(_){
                        case 'arraybuffer':
                            return [
                                3,
                                5
                            ];
                        case 'blob':
                            return [
                                3,
                                7
                            ];
                        case 'json':
                            return [
                                3,
                                9
                            ];
                        case 'application/json':
                            return [
                                3,
                                9
                            ];
                    }
                    return [
                        3,
                        11
                    ];
                case 5:
                    return [
                        4,
                        response.arrayBuffer()
                    ];
                case 6:
                    axiosResponse.data = _state.sent();
                    return [
                        3,
                        13
                    ];
                case 7:
                    return [
                        4,
                        response.blob()
                    ];
                case 8:
                    axiosResponse.data = _state.sent();
                    return [
                        3,
                        13
                    ];
                case 9:
                    return [
                        4,
                        response.json()
                    ];
                case 10:
                    axiosResponse.data = _state.sent();
                    return [
                        3,
                        13
                    ];
                case 11:
                    return [
                        4,
                        response.text()
                    ];
                case 12:
                    axiosResponse.data = _state.sent();
                    return [
                        3,
                        13
                    ];
                case 13:
                    return [
                        2,
                        axiosResponse
                    ];
            }
        });
    });
    return _getRequest.apply(this, arguments);
}
/**
 * Custom implementation around fetch for axios. This is useful for environments where axios own adapters does not suffice (eg. edge runtime).
 * This custom adapter could be removed when axios introduces its own fetch adapter.
 *
 * https://github.com/axios/axios/issues/5523
 * https://github.com/axios/axios/pull/5146
 * @deprecated Use native axios 'fetch' adapter
 */ var fetchAdapter = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(config) {
        var request, promiseChain, data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = getRequest(config);
                    promiseChain = [
                        request
                    ];
                    if (config.timeout != null && config.timeout > 0) {
                        promiseChain.push(new Promise(function(resolve) {
                            setTimeout(function() {
                                var message = config.timeoutErrorMessage ? config.timeoutErrorMessage : "timeout of ".concat(config.timeout, "ms exceeded");
                                resolve(new _axios.default.AxiosError(message, _axios.AxiosError.ECONNABORTED, config, request));
                            }, config.timeout);
                        }));
                    }
                    return [
                        4,
                        Promise.race(promiseChain)
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            if (data instanceof Error) {
                                reject(data);
                            } else {
                                settle(resolve, reject, data);
                            }
                        })
                    ];
            }
        });
    });
    return function fetchAdapter(config) {
        return _ref.apply(this, arguments);
    };
}();
exports.fetchAdapter = fetchAdapter; //# sourceMappingURL=fetchAdapter.js.map
